<template>
  <v-card class="rounded-xl" elevation="0" outlined width="100%">
    <v-card-text>
      <Line-Chart :data="data" :options="options" height="300" />
    </v-card-text>
  </v-card>
</template>
<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "vue-chartjs";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
export default {
  name: "LineCard",
  mounted: function () {},
  components: { "Line-Chart": Line },
  computed: {},
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
          ],
          datasets: [
            {
              label: "Data One",
              backgroundColor: "#f87979",
              data: [40, 39, 10, 40, 39, 80, 40],
            },
          ],
        };
      },
    },
    options: {
      type: Object,
      default: () => {
        return {
          plugins: {
            legend: {
              display: true,
            },
            title: {
              display: true,
              text: "Amount vs Month",
            },
          },
          responsive: true,
          maintainAspectRatio: false,
        };
      },
    },
  },
  data() {
    return {};
  },
};
</script>
